import React, { Component } from 'react';

import { Link } from 'react-router-dom';
export default class NotFoundBlock extends Component {
  render() {
    return (
      <div className="NotFoundBlock">
        <div className="nfb__title">Oeps,</div>
        <div className="nfb__comment">
          Helaas kunnen we de opgevraagde pagina niet vinden...
        </div>
        <div className="nfb__redirect">
          Klik{' '}
          <Link to="/">
            <b>hier</b>
          </Link>{' '}
          om terug te gaan naar de homepage
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFoundBlock/NotFoundBlock.jsx